import { render } from "./friendItem.vue?vue&type=template&id=5bc9ebfa&scoped=true"
import script from "./friendItem.vue?vue&type=script&lang=js"
export * from "./friendItem.vue?vue&type=script&lang=js"

import "./friendItem.vue?vue&type=style&index=0&id=5bc9ebfa&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc9ebfa"]])

export default __exports__